export default "__VITE_ASSET__DYyr1uTP__"